import min from "./min";
import max from "./max";
import count from "./count";
import average from "./average";
import total from "./total";
import variance from "./variance";
import standardDeviation from "./standard-deviation";
import median from "./median";

export default {
    min,
    max,
    count,
    average,
    total,
    variance,
    standardDeviation,
    median
}


// WEBPACK FOOTER //
// ./src/aggregators/aggregators.js